import type { MantineThemeOverride, NumberInputProps } from '@mantine/core';

import { mantineComponentDefaults } from './mantineThemeDefaults';

interface AppThemeOptions {
  decimalSeparator?: string;
  numberInputExtras?: Partial<NumberInputProps>;
  readOnlyControls?: 'segmented' | 'all';
}

export const APP_FONT_FAMILY = 'Inter, system-ui, sans-serif';

/** Shared shell defaults, with only the controls each shell previously customized. */
export function buildAppTheme({
  decimalSeparator,
  numberInputExtras,
  readOnlyControls,
}: AppThemeOptions = {}): MantineThemeOverride {
  return {
    fontFamily: APP_FONT_FAMILY,
    components: {
      ...mantineComponentDefaults(decimalSeparator, numberInputExtras),
      ...(readOnlyControls && {
        SegmentedControl: {
          defaultProps: () => ({
            styles: (_: unknown, props: { readOnly?: boolean }) => ({
              root: {
                opacity: props.readOnly ? 0.8 : 1,
                pointerEvents: props.readOnly ? 'none' : 'auto',
              },
            }),
          }),
        },
      }),
      ...(readOnlyControls === 'all' && {
        Select: {
          defaultProps: () => ({
            styles: (_: unknown, props: { readOnly?: boolean }) => ({
              input: {
                backgroundColor: props.readOnly ? 'var(--view-only-bg)' : '',
                pointerEvents: props.readOnly ? 'none' : 'auto',
                cursor: props.readOnly ? 'not-allowed' : 'auto',
              },
            }),
          }),
        },
      }),
    },
  };
}
